import React, {Fragment} from 'react'

import BkFlowRoomCardDefaultRateToggle from './BkFlowRoomCardDefaultRateToggle'
import BkFlowRoomCardDefaultSelectButton from './BkFlowRoomCardDefaultSelectButton'
import BkFlowRoomCardSkipStepButton from '../../BkFlowRoomCardSkipStepButton'
import BkFlowRoomCardActiveDestinationFee from './BkFlowRoomCardActiveDestinationFee'

import _ from 'lodash'
import BkFlowMaterialLoader from '../../../../elements/BkFlowMaterialLoader'

const BkFlowRoomCardConfiguredRates = props => {
  const {
    activeCurrencyData,
    activeRoomsAmount,
    cards,
    configData,
    currentRateCode,
    currentRoomType,
    currentUpSells,
    displayedPriceFrequency,
    hotelLabels,
    loyaltyRateLoading,
    multiRoomData,
    payLaterRatePlan,
    payLaterRoomRate,
    payNowRatePlan,
    payNowRoomRate,
    queriedRatePlan,
    queriedRoomRate,
    renderFeaturedRateToggles,
    renderLoyaltyRateToggles,
    renderPromoRateToggles,
    roomGroup,
    setSelectedRoom,
    toggleActiveRoom,
    totalNights,
    upSellsToggleEvent,
    urlData,
  } = props

  return (
    <div className="bk-flow-room__pricing configured-rates row">
      { urlData.ratePlanCode ?
        <Fragment>
          { loyaltyRateLoading ?
            <BkFlowMaterialLoader
              parentClasses='loyalty-rates-loading u-txt-center'
              color={'#000'}
              size={15}
            />
          : !_.isEmpty(renderLoyaltyRateToggles) ?
            renderLoyaltyRateToggles
          : null }

          { queriedRoomRate &&
            queriedRatePlan &&
            <BkFlowRoomCardDefaultRateToggle
              activeCurrencyData={ activeCurrencyData }
              configData={configData}
              currentRateCode={ currentRateCode }
              displayedPriceFrequency={displayedPriceFrequency}
              hotelLabels={ hotelLabels }
              ratePlanData={ queriedRatePlan }
              roomGroup={ roomGroup }
              roomRateData={ queriedRoomRate }
              roomTypeData={cards}
              setSelectedRoom={ setSelectedRoom }
              totalNights={ totalNights }
            />
          }

          <BkFlowRoomCardDefaultSelectButton
            currentRoomType={currentRoomType}
            currentRateCode={currentRateCode}
            currentUpSells={currentUpSells}
            toggleActiveRoom={toggleActiveRoom}
            upSellsToggleEvent={() => upSellsToggleEvent()}
            roomGroup={roomGroup}
          />
        </Fragment>
      : urlData.promoCode && !_.isEmpty(renderPromoRateToggles)  ?
        <Fragment>
          { loyaltyRateLoading ?
            <BkFlowMaterialLoader
              parentClasses='loyalty-rates-loading u-txt-center'
              color={'#000'}
              size={15}
            />
          : !_.isEmpty(renderLoyaltyRateToggles) ?
            renderLoyaltyRateToggles
          : null }

          { renderPromoRateToggles }

          <BkFlowRoomCardDefaultSelectButton
            currentRoomType={currentRoomType}
            currentRateCode={currentRateCode}
            currentUpSells={currentUpSells}
            toggleActiveRoom={toggleActiveRoom}
            upSellsToggleEvent={() => upSellsToggleEvent()}
            roomGroup={roomGroup}
          />
        </Fragment>
      :
        <Fragment>
          { (payNowRoomRate || payLaterRoomRate || !_.isEmpty(renderFeaturedRateToggles) || !_.isEmpty(renderLoyaltyRateToggles)) &&
            <div className="bk-flow-room__pricing-buttons">
              { loyaltyRateLoading ?
                <BkFlowMaterialLoader
                  parentClasses='loyalty-rates-loading u-txt-center'
                  color={'#000'}
                  size={15}
                />
              : !_.isEmpty(renderLoyaltyRateToggles) ?
                renderLoyaltyRateToggles
              : null }

              { _.isEmpty(renderLoyaltyRateToggles) &&
                payNowRoomRate &&
                payNowRatePlan &&
                  <BkFlowRoomCardDefaultRateToggle
                    activeCurrencyData={ activeCurrencyData }
                    currentRateCode={ currentRateCode }
                    displayedPriceFrequency={displayedPriceFrequency}
                    genericRateLabel={ hotelLabels.payNow ? hotelLabels.payNow : 'Pay Now' }
                    hotelLabels={ hotelLabels }
                    ratePlanData={ payNowRatePlan }
                    roomGroup={ roomGroup }
                    roomRateData={ payNowRoomRate }
                    roomTypeData={cards}
                    setSelectedRoom={ setSelectedRoom }
                    totalNights={ totalNights }
                  />
              }

              { payLaterRoomRate &&
                payLaterRatePlan &&
                  <BkFlowRoomCardDefaultRateToggle
                    activeCurrencyData={ activeCurrencyData }
                    currentRateCode={ currentRateCode }
                    displayedPriceFrequency={displayedPriceFrequency}
                    genericRateLabel={ hotelLabels.payLater ? hotelLabels.payLater : 'Pay Later' }
                    hotelLabels={ hotelLabels }
                    ratePlanData={ payLaterRatePlan }
                    roomGroup={ roomGroup }
                    roomRateData={ payLaterRoomRate }
                    roomTypeData={cards}
                    setSelectedRoom={ setSelectedRoom }
                    totalNights={ totalNights }
                  />
              }

              { !_.isEmpty(renderFeaturedRateToggles) && renderFeaturedRateToggles }
            </div>
          }

          <div className="bk-flow-room__actions-buttons">
            <BkFlowRoomCardActiveDestinationFee
              cards={cards}
              configData={configData}
              currentRateCode={currentRateCode}
              hotelLabels={ hotelLabels }
              roomTypeData={cards}
              urlData={urlData}
            />

            <BkFlowRoomCardDefaultSelectButton
              currentRoomType={currentRoomType}
              currentRateCode={currentRateCode}
              currentUpSells={currentUpSells}
              toggleActiveRoom={toggleActiveRoom}
              upSellsToggleEvent={() => upSellsToggleEvent()}
              roomGroup={roomGroup}
            />

            { multiRoomData.isMultiRoom &&
              activeRoomsAmount === multiRoomData.multiRoomTotal &&
              <BkFlowRoomCardSkipStepButton customClass="desktop" />
            }
          </div>
        </Fragment>
      }
    </div>
  )
}

export default BkFlowRoomCardConfiguredRates



// WEBPACK FOOTER //
// ./src/components/room/elements/default/configured/BkFlowRoomCardConfiguredRates.js